
































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import { BroadcastsTypes, Company, dateTypes } from '../../core/models';
import { activeFormatter, ColorsList, formatDate, formattedDate, getCurrentTimestamp, getVehicleIconByAlertType, OptionalCompany } from '../../core/utils';
import { VehicleAlert, VehicleProperties } from '../models/Vehicle';
import VehicleAlertsIcons from './VehicleAlertsIcons.vue'
import { SettingsService } from '../api/SettingsService';

@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle,
        VehicleAlertsIcons
    }
})
export default class VehicleAlerts extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default(){return {}}}) vehicleProperties: VehicleProperties;
    @Prop({default: -1}) vehicleId: number;
    @Prop({default: ''}) vehicleDescription: string;
    alerts: Array<VehicleAlert> = [];
    orangeColor: string = ColorsList.orange;
    modalTitle: string = 'Estado actual de Alertas';
    
    gettingAlerts: boolean = false;
   
    

    getVehicleAlerts(){
        this.gettingAlerts = true;
        this.alerts = [];
        let currentVehicle = Number(this.vehicleId);
        SettingsService.getVehicleAlerts(
            [currentVehicle]
        ).then((res) => {
            this.alerts = res[currentVehicle].errors;
            // this.alerts = [
            //     {
            //         acknowledge_date: null,
            //         type: 0,
            //         active: true,
            //         reported_date: '2023-03-02T23:59:00'
            //     },
            //     {
            //         acknowledge_date: null,
            //         type: 1,
            //         active: true,
            //         reported_date: '2023-03-02T23:59:00'
            //     }
            // ]
            this.gettingAlerts = false;
        }).catch((err) => {
            this.gettingAlerts = false;
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudieron obtener las alertas'
            });
        })
    }

    get existsAlerts(){
        return this.alerts.filter(alert => alert.active).length > 0
    }


    

    
    
    


    dateFormatter(value) {
        if(value == null) return '-'
        return formattedDate(value, true);
    }

    boolFormatter(value){
        return activeFormatter(value)
    }

   
    deactivateAlertsSuccess(vehicleIds: number[], acknowledgeDate: string){
         this.alerts = this.alerts.map(function(alert){
            return {
                ...alert,
                active: false,
                acknowledge_date: acknowledgeDate
            }
        })
    }

    @Emit()
    closeModal() {
       
    }

    mounted() {
        this.$nextTick(() => {
            this.getVehicleAlerts();
        });
    }
}
